// extracted by mini-css-extract-plugin
export default {"faq-list":"FaqList_faq-list__XAE9u"};